import { InjectionToken } from '@angular/core';
import { Icons } from '../ce-icon/ICONLIB';

// TODO: Use this enum to set the state / style of the snackbar
export enum CeSnackbarState {
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error',
    LOADING = 'loading',
    DEFAULT = 'default',
}

export enum CeSnackbarDelays {
    VISIBILITY = 5000, // text-only
    ACTIONS_VISIBILITY = 7000, // with actions or explicit close
    ANIMATION = 300,
}

export interface SnackbarAction {
    label: string;
    onClick: () => void;
}

// TODO: Add more options to the snackbar data (close button, position, etc.)
export interface SnackbarData {
    /**
     * @description The message to be displayed in the snackbar
     * @type {string}
     */
    message: string;

    /**
     * @description The state of the snackbar (success, warning, error, default) to determine the style of the snackbar
     * @todo Currently only the default state is supported and any other state will be ignored
     * @type {CeSnackbarState}
     */
    state?: CeSnackbarState;

    /**
     * @description The duration in milliseconds after which the snackbar will be hidden
     * @type {number | 'persist'}
     */
    duration?: number | 'persist';

    /**
     * @description Whether the snackbar should be closed when the user navigates to a different route
     * @type {boolean}
     * @default true
     */
    closeOnNavigation?: boolean;

    /**
     * @description Icon to display in the snackbar
     * @type {keyof Icons}
     */
    icon?: keyof Icons;

    /**
     * @description Actions to display in the snackbar (e.g., Close button)
     * @type {SnackbarAction[]}
     */
    actions?: SnackbarAction[];

    /**
     * @description Whether to show an explicit close (X) button. Defaults to true for error; otherwise false unless set.
     */
    showCloseButton?: boolean;

    /**
     * Defines a special use case: used inside <dialog> or in full screen sized component. Affects the appearance place in DOM.
     *
     * @example
     * ```ts
     * snackbarService.showSnackbar({
     *   message: 'Saved',
     *   state: CeSnackbarState.SUCCESS,
     *   customOverlay: { enabled: true, overlaySelector: '.modal-overlay-container' },
     * });
     * ```
     */
    customOverlay?: {
        enabled: boolean;
        /** CSS selector for the target container element (e.g. '.modal-overlay-container'). */
        overlaySelector: string;
    };
}

export const CE_SNACKBAR_DATA = new InjectionToken<SnackbarData>('SNACK_BAR_DATA');

export const CE_SNACKBAR_CLOSE = new InjectionToken<() => void>('SNACK_BAR_CLOSE');
